import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconClose = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#4D4D4D",
		fillRule: "evenodd",
		d: "M9.48 7l4.39-4.39a.445.445 0 0 0 0-.626L12.02.13a.444.444 0 0 0-.627 0L7.001 4.522 2.607.13a.443.443 0 0 0-.625 0L.129 1.982a.444.444 0 0 0 0 .627L4.523 7 .131 11.394a.446.446 0 0 0 0 .625l1.852 1.853a.447.447 0 0 0 .626 0L7.001 9.48l4.39 4.39a.445.445 0 0 0 .626 0l1.853-1.854a.448.448 0 0 0 0-.626L9.48 7z"
	})]
});
const ForwardRef = forwardRef(SvgIconClose);
export default ForwardRef;
